<div class="advanced-dropdown-container">
  <div #trigger class="dropdown-trigger">
    <!-- Input box styled as select - readonly with custom clear button -->
    <ejs-textbox
      [placeholder]="placeholder"
      [value]="selectedText"
      [cssClass]="'e-outline advanced-ejs-textbox'"
      [showClearButton]="false"
      [readonly]="true"
      (click)="toggleDropDown()"
    ></ejs-textbox>
    <div class="dropdown-controls">
      <div class="loading-indicator" *ngIf="loading">
        <div class="loading-spinner"></div>
      </div>
      <span *ngIf="selectedId && showClearButton && !loading" class="clear-icon" (click)="clearSelection($event)">
        <i class="fa fa-times-circle"></i>
      </span>
      <span class="dropdown-icon">
        <mat-icon *ngIf="!isOpen">arrow_drop_down</mat-icon>
        <mat-icon *ngIf="isOpen">arrow_drop_up</mat-icon>
      </span>
    </div>
  </div>

  <!-- Custom dropdown template -->
  <ng-template #dropdownTemplate>
    <div class="custom-dropdown-overlay">
      <!-- Header -->
      <div class="dropdown-header">        
        <!-- Search input -->
        <div class="dropdown-search">
          <ejs-textbox 
            placeholder="Search..."
            [(value)]="searchText"
            (input)="onFiltering($event.value)"
            [cssClass]="'e-outline search-textbox'"
          ></ejs-textbox>
        </div>
      </div>
      <div>
        <table class="dropdown-table-header">
          <tr>
            <td *ngFor="let col of columns" [style.width]="col.width" [style.max-width]="col.width" [style.min-width]="col.width" class="mouse-pointer" (click)="headerCellClicked(col.field)">
              <div class="col-header-cell">
                <span class="col-header-text">{{ col.header | translate }}</span>
                <span class="col-header-sort-icons">
                <mat-icon class="sort_icon" *ngIf="sortField === col.field && sortDirection === 'asc'">arrow_upward</mat-icon>
                <mat-icon class="sort_icon" *ngIf="sortField === col.field && sortDirection === 'desc'">arrow_downward</mat-icon>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <!-- Items list -->
      <div class="dropdown-items-container" [class.loading]="loading">
        <div class="loading-overlay" *ngIf="loading">
          <div class="loading-spinner"></div>
          <div class="loading-text">Loading data...</div>
        </div>
        <div 
          *ngFor="let item of filteredItems" 
          class="dropdown-item"
          (click)="onItemSelect(item)"
          [class.selected]="item.id === selectedId"
        >
          <table class="dropdown-table">
            <tbody>
              <tr>
                <td *ngFor="let col of columns" [style.width]="col.width" [style.max-width]="col.width" [style.min-width]="col.width">
                  <ng-container *ngIf="col.cellTemplate; else defaultCell">
                    <ng-container *ngTemplateOutlet="col.cellTemplate; context: { $implicit: item }"></ng-container>
                  </ng-container>
                  <ng-template #defaultCell>
                    <span [appHighlightSearch]="item[col.field] || ''" [searchTerm]="filteredSearchText" [highlightClass]="'highlighted-text'" class="cell-content"></span>
                  </ng-template>
                </td>
              </tr>
            </tbody>    
          </table>
        </div>
      </div>

      <!-- Footer -->
      <div class="dropdown-footer">
        <div class="filter-results">{{getFilterResultsMessage()}}</div>
        <div class="footer-buttons" *ngIf="showFooter">
          <button
            mat-flat-button
            class="add-new-item-button"
            siteUsageTracker
            [logCategory]="translationPrefix"
            [logName]="'createButton'"
            (click)="onCreateClick()"
            [disabled]="disableCreateButton"
          >
            <mat-icon>add</mat-icon>
            {{ translationPrefix + '.Create' | translate }}
          </button>
          <button
            mat-flat-button
            color="primary"
            siteUsageTracker
            [logCategory]="translationPrefix"
            [logName]="'saveButton'"
            (click)="onSaveClick()"
            [disabled]="!selectedId || disableSaveButton"
          >
            <mat-icon>save</mat-icon>
            {{ translationPrefix + '.Save' | translate }}
          </button>          
        </div>
      </div>
    </div>
  </ng-template>
</div> 